import { Button, ButtonProps, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { useModal } from '../../../components/modal/useModal';
import { IModuleParam } from '../../../redux/progress/module/moduleInterface';
import DirPicker from '../filepicker/DirPicker';
import FilePicker from '../filepicker/FilePicker';
import { IFileInfo } from './fileinfo.interfact';
import LocalButton from './LocalButton';


export interface RealTimeParamsPropies {
    value?: string;
    onChange?: (value: string) => void;
    param: IModuleParam
}

export default function RealTimeFileItem(props: RealTimeParamsPropies) {
    const [showModal, modalJsx, closeModal] = useModal();

    const [fileInfo, setFileInfo] = useState<IFileInfo>({
        name: '',
        content: '',
    });

    useEffect(() => {
        if (props.onChange) {
            props.onChange(fileInfo.content);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fileInfo.content]);

    useEffect(() => {
        if (props.value !== fileInfo.content) {
            setFileInfo({
                name: fileInfo.name,
                content: props.value || '',
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.value]);

    const createButton = () => {

        const propies: ButtonProps = {
            type: "primary",
            style: { width: '50px' },
        }

        let node = <Button
            {...propies}
            onClick={() => {
                if (props.param.ISDIR) {
                    showModal(<DirPicker onChange={(val) => {
                        setFileInfo({
                            name: val.split('/').pop() || '',
                            content: val,
                        });
                    }} close={closeModal} param={props.param} />)
                } else {
                    showModal(<FilePicker onChange={(val) => {
                        setFileInfo({
                            name: val.split('/').pop() || '',
                            content: val,
                        });
                    } } close={closeModal} param={props.param} diffraction={''} />)
                }
            }}
        >...</Button>

        node = <LocalButton
            {...propies}
            fileValue={fileInfo}
            param={props.param}
            onFileChanged={setFileInfo}
        >
            {node}
        </LocalButton>

        return node;
    }

    return <>
        <Input.Group compact>
            <Input
                value={fileInfo.name}
                style={{ width: 'calc(100% - 50px)' }}
            />
            {createButton()}
        </Input.Group>
        {modalJsx}
    </>
}